// src/pages/yenimahalle/MapSection.tsx
import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { Container as ContainerBase } from "components/misc/Layouts.js";

const FullBleedContainer = styled(ContainerBase)`
  ${tw`bg-secondary-800`};
  /* cancel out the page padding so this goes full‑width */
  margin-left: -2rem;
  margin-right: -2rem;

  @media (min-width: 640px) {
    margin-left: -1rem;
    margin-right: -1rem;
  }
  @media (min-width: 1024px) {
    margin-left: 0;
    margin-right: 0;
    /* assuming your main layout centers again at lg */
  }
`;

const Frame = styled.iframe`
  ${tw`w-full`}
  height: 30vh;
  border: none;
`;

export default () => (
  <FullBleedContainer>
    <Frame
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6116.146139323048!2d32.810155!3d39.962119!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34eb2c15280cf%3A0xe98573795dcafcf7!2sYenimahalle%20Municipality!5e0!3m2!1sen!2str!4v1744896009285!5m2!1sen!2str"
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Yenimahalle Municipality"
    />
  </FullBleedContainer>
);
